<div>
    <div >
      <app-empresa-dropdown [(selecionadas)]="instanciaSelecionada" modo="unico" (funcaoChange)="carregaPeriodos($event)"/>
        <!-- <p-dropdown
        appendTo="body"
        [options]="instancias"
        [filter]="true"
        [style]="{ width: '200px' }"
        optionValue="id"
        optionLabel="nome"
        [(ngModel)]="instanciaSelecionada"
        dataKey="id"
        inputId="id"
        placeholder="Instância"
        emptyMessage="Nenhuma instância"
        (onChange)="carregaPeriodos($event)"
      >
      </p-dropdown> -->
      <p-dropdown
      class="ml-3"
        appendTo="body"
        [options]="periodosLiberados"
        [filter]="true"
        [style]="{ width: '300px' }"
        
        optionLabel="nome"
        [(ngModel)]="periodoSelecionado"
        
        placeholder="Períodos"
        emptyMessage="Nenhum Período"
        (onChange)="carregaDadosRetorno()"
        
      >
      <ng-template pTemplate="selectedItem">
        <div class="flex align-items-center gap-2" *ngIf="periodoSelecionado">
          <div>Período de {{ periodoSelecionado.dataInicio | date: 'dd/MM/yyyy' }} à {{ periodoSelecionado.dataFim | date: 'dd/MM/yyyy' }}</div>
        </div>
    </ng-template>
      <ng-template let-periodo pTemplate="item">
        <div class="flex align-items-center gap-2">
            <div>Período de {{ periodo.dataInicio | date: 'dd/MM/yyyy' }} à {{ periodo.dataFim | date: 'dd/MM/yyyy' }}</div>
        </div>
    </ng-template>
      </p-dropdown>

      <p-button
        class="ml-3"
        
        pRipple
        icon="pi pi-arrow-down-right"
        label="Buscar do PIMS"
        [loading]="loading"
        [disabled]="loading"
        (onClick)="sincronizar()"
      ></p-button>

      <p-button
        class="ml-3"
        
        pRipple
        icon="pi pi-arrow-up-right"
        label="Enviar ao ERP"
        [loading]="loading"
        [disabled]="loading"
        (onClick)="requisitaIntegracao()"
      ></p-button>

      <p-button
        class="ml-3"
        
        pRipple
        icon="pi pi-refresh"
        label="Reverter"
        [loading]="loading"
        [disabled]="loading"
        (onClick)="reverter()"
      ></p-button>

      <p-button
        class="ml-3"
        
        pRipple
        icon="pi pi-file-excel"
        label="Exportar"
        [loading]="loading"
        [disabled]="loading"
        (onClick)="exportar()"
      ></p-button>

      <div class="mt-3">
        <p-table [value]="retornoCusto" dataKey="id" [loading]="loading" #dt [globalFilterFields]="['instancia','cdProcesso']" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [rowsPerPageOptions]="[20, 50, 100]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="{{retornosSelecionados.length}} Registros selecionados | Mostrando de {first} até {last} de {totalRecords} registros" [(selection)]="retornosSelecionados">
    
          <ng-template pTemplate="header">
              <tr>
                <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
                <th>Instância</th>
                <th>Empresa ERP</th>
                <th>Filial ERP</th>
                <th>Dt. Lançamento</th>
                <th>Lote</th>
                <th>Tipo</th>
                <th>Lançamento</th>
                <th>Sequência</th>
                <th>Natureza</th>
                <th>Centro Custo ERP</th>
                <th>Conta ERP</th>
                <th>Descrição</th>
                <th>Valor</th>
                <th pSortableColumn="statusIntegracao">Status <p-sortIcon field="statusIntegracao" /></th>
                <th>Dt. Integração</th>
                <th>Documento ERP</th>
                <th>Mensagem</th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-retorno>
              <tr>
                <td><p-tableCheckbox [value]="retorno" /></td>
                <td>{{ retorno.instancia }}</td>
                <td>{{ retorno.empresaErp }}</td>
                <td>{{ retorno.filialErp }}</td>
                <td>{{ retorno.dataLancamento }}</td>
                <td>{{ retorno.lote }}</td>
                <td>{{ retorno.tipo }}</td>
                <td>{{ retorno.lancamento }}</td>
                <td>{{ retorno.sequencia }}</td>
                <td>{{ retorno.natureza }}</td>
                <td>{{ retorno.centroCustoErp }}</td>
                <td>{{ retorno.contaErp }}</td>
                <td>{{ retorno.historico }}</td>
                <td>{{ retorno.valor.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2})  || 0 }}</td>
                <td><app-tag-status [status]="retorno.statusIntegracao" ></app-tag-status> </td>
                <td>{{ retorno.dtIntegracao }}</td>
                <td>{{ retorno.noDocErp }}</td>
                <td>{{ retorno.deMensagemInteg }}</td>
              </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
              <td colspan="10">Nenhum registro encontrado</td>
          </ng-template>
      </p-table>
      </div>
</div>
